import axios from 'axios';
import _isArray from 'lodash/isArray';
import _find from 'lodash/find';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import * as Page from '../../lib/page';
import { trackSetUp } from '../../lib/analytics-helper';

function requestArticles() {
  return {
    type: types.REQUEST_ARTICLE_LIST,
  };
}

function receiveArticlesResponse(topicList, response, selectedTopic) {
  // Get article page title and Id by using selected topic
  const articleTitle = _get(_find(topicList.topics, topic => String(topic.topicId) === selectedTopic), 'topicName');
  const articleId = _get(_find(topicList.topics, topic => String(topic.topicId) === selectedTopic), 'topicId');

  // Set article List by using L2 response data
  // No Article Limit for the Topic page
  const articleList = [];
  if (response && response.length > 0) {
    response.forEach((articleSet) => {
      // HACK: Limit the article list to 20
      let faqList = _isArray(articleSet.articles) && articleSet.articles;
      if (faqList && faqList.length > 20) {
        faqList = faqList.slice(0, 20);
      }

      articleList.push({
        id: articleSet.subTopicId,
        name: articleSet.subTopicName,
        faqList,
      });
    });
  }

  return {
    type: types.RECEIVE_ARTICLE_LIST,
    payload: {
      articleList,
      articleTitle,
      articleId,
    },
  };
}

function receiveArticlesError() {
  return {
    type: types.RECEIVE_ARTICLE_LIST_ERROR,
  };
}

export default function getFaqList(topicList, topicSelected) {
  return (dispatch) => {
    dispatch(requestArticles());
    const topicTreeUrl = `/smarthelp/web-topic-tree?q=${topicSelected}`;
    return axios.get(Page.setChannelForTechnicalExp(topicTreeUrl))
      .then((response) => {
        // FPTI for topic impression event
        trackSetUp({ id: 'topicPage', link: `smarthelp-topic|${topicSelected}` });

        dispatch(receiveArticlesResponse(topicList, response.data.webTopicTree, topicSelected));
      })
      .catch(() => {
        trackSetUp({ id: 'topicErrorPage', link: `smarthelp-error-topics|${topicSelected}` });

        dispatch(receiveArticlesError());
      });
  };
}
